export const YEAR_FORMAT = "dddd";
export const MONTH_FORMAT = "YYYY-MM";
export const MONTH_SUMMARY_FORMAT = "MMMM YYYY";
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm";
export const DETAILED_DATE_TIME_FORMAT = "dddd, MMMM Do YYYY, HH:mm:ss";
export const TIME_FORMAT = "HH:mm";
export const WEEK_DAYS = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
export const INTERVAL_TYPES = ["YEAR", "MONTH", "DAY", "HOUR", "MINUTE", "SECOND"];
export const DEFAULT_DATE = "2020-01-01";
export const DEFAULT_DATE_VIEWS = ["year", "month", "date"];

